import { Container, Row, Col, Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import {
  useTranslator,
  useAppContext,
  dateTimeToDate,
  withMobileAppMode,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';

const DietInFuture = ({ date, renderTimeline, mealPlanNavigation, mobileAppMode }) => {
  const { t } = useTranslator();
  const {
    images: { dietInFuture },
  } = useAppContext();

  const numberOfDays =
    1 + (dateTimeToDate(date) - dateTimeToDate(new Date())) / 1000 / 60 / 60 / 24;

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('meals.navbarTitle')}</TitleBar>
      {renderTimeline()}
      <div className="page-template-other full-height3">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                {mealPlanNavigation && mealPlanNavigation.length > 0 && (
                  <div className="sub-navigation text-center">
                    <Container>
                      <Nav className="d-block">
                        {mealPlanNavigation.map((item) => (
                          <NavItem>
                            <NavLink to={item.path} replace={true} className="nav-link">
                              {t(item.translationKey)}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Nav>
                    </Container>
                  </div>
                )}
                <div
                  className={
                    mobileAppMode
                      ? 'other-container text-center d-flex align-items-center min-height2'
                      : 'other-container text-center'
                  }
                >
                  <Row>
                    <Col xl={{ size: 6, offset: 3 }}>
                      <img src={dietInFuture} className="img-fluid mb-xl" alt="" />
                      <h2 className="title-medium semi-bold">
                        {t('mealPlan.dietFuture.screen.title', {
                          count: numberOfDays,
                        })}
                      </h2>
                      <p className="mb-0 text-text-variant-color">
                        {t('mealPlan.dietFuture.screen.content', {
                          count: numberOfDays,
                        })}
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default withMobileAppMode(DietInFuture);
